<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Col>
                        <Form :model="journal" :label-width="85" label-position="right"
                              ref="form">
                            <FormItem :label="t.journal.title" prop="title">
                                <Input v-model="journal.title" readonly></Input>
                            </FormItem>

                            <FormItem :label="t.journal.type" prop="type">
                                <Input v-model="journal.type" readonly></Input>
                            </FormItem>

                            <Form-item :label="t.journal.releaseDate">
                                <Input v-model="journal.releaseDate" readonly></Input>
                            </Form-item>
                            <FormItem :label="t.journal.status" prop="status">
                                <Input v-model="journal.status" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.journal.body" prop="body">
                                <Input v-model="journal.body"
                                       :autosize="{minRows: 6}"
                                       readonly
                                       type="textarea"></Input>
                            </FormItem>
                            <FormItem :label="t.journal.description" prop="description">
                                <tinymce id="id1" v-model="journal.description" :toolbar1="toolbar1"
                                         :other_options="other_options" readonly></tinymce>
                            </FormItem>
                            <FormItem :label="t.journal.createBy" prop="createBy">
                                <Input v-model="journal.createBy" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.journal.createTime" prop="createTime">
                                <Input v-model="journal.createTime" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.journal.updateBy" prop="updateBy">
                                <Input v-model="journal.updateBy" readonly></Input>
                            </FormItem>
                            <FormItem :label="t.journal.updateTime" prop="updateTime">
                                <Input v-model="journal.updateTime" readonly></Input>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </Row>
    </div>
</template>
<script>
import { edit, getJournalInfo } from '@/api/journal';

export default {
    name: 'content_journal_detail',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            journal: {
                title: '',
                type: '0',
                releaseDate: '',
                sortOrder: 0,
                status: '1',
                body: '',
                description: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
            },
            loading: false,
            toolbar1: 'newnote print preview code',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
            },
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    methods: {
        async init() {
            const journalsInfo = await getJournalInfo(this.$route.params.id);
            if (journalsInfo.journal != null) {
                this.journal = journalsInfo.journal;
                //状态判断
                if (this.journal.status === '1') {
                    this.journal.status = this.t.journal.open;
                } else if (this.journal.status === '0') {
                    this.journal.status = this.t.journal.close;
                }
                //类型判断
                if (this.journal.type === '1') {
                    this.journal.type = this.t.journal.dayJournal;
                    this.journal.releaseDate =
                        this.journal.releaseYear + '/' + this.journal.releaseMonth + '/' + this.journal.releaseDay;
                } else if (this.journal.type === '0') {
                    this.journal.type = this.t.journal.monthJournal;
                    this.journal.releaseDate = this.journal.releaseYear + '/' + this.journal.releaseMonth;
                }
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
</style>
^
